'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Select = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Field2 = require('./Field');

var _index = require('./inputs/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = exports.Select = (_temp = _class = function (_Field) {
	_inherits(Select, _Field);

	function Select(props) {
		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		_this.options = _this.props.options;
		return _this;
	}

	_createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			_get(Select.prototype.__proto__ || Object.getPrototypeOf(Select.prototype), 'componentWillMount', this).call(this);

			if (this.options == null) {
				if (this.props.loadOptions != null) {
					this.options = this.props.loadOptions();
				}
			}
		}

		// componentDidUpdate(prevProps) {
		// 	if (prevProps.options != this.props.options) {
		// 		this.options = this.props.options;
		// 	}
		// }

	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options != this.options) {
				if (nextProps.options != null) {
					this.options = nextProps.options;
				}
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(props) {
			props.options = this.options;
			props.value = this.props.value;
			props.ignoreValueUpdates = true;

			props.sortEntries = this.props.sortEntries;

			return _react2.default.createElement(_index.ESInput.Select, _extends({}, props, { ref: "select" }));
		}
	}]);

	return Select;
}(_Field2.Field), _class.defaultProps = Object.assign({}, _Field2.Field.defaultProps, {
	sortEntries: true,
	value: null,
	options: null,
	loadOptions: function loadOptions() {}
}), _temp);